import type { BillingFeatureId, QuotaType } from '@bpinternal/const'

/**
 * Maps a legacy {@link QuotaType} to the smaug (billing v4) {@link BillingFeatureId} it corresponds to.
 *
 * Smaug exposes usage through `getWorkspaceUsages`, keyed by billing feature id, while the rest of the
 * dashboard still speaks in `QuotaType`. This table lets us translate v4 usage back into the shape the
 * usage UI expects.
 *
 * Legacy quota types with no v4 equivalent (e.g. `always_alive`, `workspace_ratelimit`, `invocation_timeout`,
 * `openai_spend`, `bing_search_spend`, `integrations_owned_count`, `file_max_size_bytes`) are intentionally
 * absent — they resolve to an empty usage on v4 workspaces.
 */
export const QUOTA_TYPE_TO_BILLING_FEATURE_ID: Partial<Record<QuotaType, BillingFeatureId>> = {
  ai_spend: 'ai_spend',
  invocation_calls: 'incoming_messages_events',
  table_row_count: 'table_rows',
  knowledgebase_vector_storage: 'vector_db_storage',
  storage_count: 'file_storage',
  workspace_member_count: 'collaborator_count',
  bot_count: 'bot_count',
  indexed_file_count: 'indexed_file_count',
}
